// extracted by mini-css-extract-plugin
module.exports = {"root":"Preloader_root__-eXqg","icon":"Preloader_icon__NTTVP","pulse":"Preloader_pulse__KANxx"};